(ns common.schema.entities.workspace.kyc.questions.prefill-data
  (:require [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]
            [common.entity :as entity]
            [common.country :as country]))

(defn default-data [template-schema legal-entity]
  (->> template-schema
       (kyc-utils/schema-questions)
       (keep (fn [[question-attribute question-meta]]
               (when-let [v (or (:default-value question-meta)
                                (case question-attribute
                                  :kyc-legal-entity/address (:asset/street-address legal-entity)
                                  :kyc-legal-entity/city (:asset/city legal-entity)
                                  :kyc-legal-entity/zip-code (:asset/zip-code legal-entity)
                                  :kyc-legal-entity/country (first (:asset/country legal-entity))
                                  :kyc-legal-entity/business-id (:company/business-id legal-entity)
                                  :kyc-legal-entity/name (entity/display-string legal-entity)
                                  :kyc-person/first-name (:person/first-name legal-entity)
                                  :kyc-person/last-name (:person/last-name legal-entity)
                                  :kyc-person/address (:person/location-address legal-entity)
                                  :kyc-person/city (:person/location-city legal-entity)
                                  :kyc-person/zip-code (:person/location-zip-code legal-entity)
                                  :kyc-person/country (country/resolve-from-name (:person/location-country legal-entity))
                                  :kyc-person/email (:person/universal-email-address legal-entity)
                                  :kyc-person/phone (:person/universal-phone-number legal-entity)
                                  nil))]
                 [question-attribute v])))
       (into {})))
